"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const GeoFire_1 = __importDefault(require("../utils/GeoFire"));
const getEnsuredProjectIdFromProcessor_1 = __importDefault(require("../getEnsuredProjectIdFromProcessor"));
const getNumberFromUnknown_1 = __importDefault(require("../../shared/getNumberFromUnknown"));
const callableGeoFireSetBuilder = async ({ functionId, callbacks, executeProcesses, processor, entryVars: { keyLocation, latitude, longitude, groupName, data, }, }) => {
    try {
        const projectId = (0, getEnsuredProjectIdFromProcessor_1.default)('geoFireSet', processor);
        const appGeofireDbRef = groupName
            ? processor.root.firebase.database().ref(`projects/${projectId}/geoFireGroups/${groupName}`)
            : processor.root.firebase.database().ref(`projects/${projectId}/geoFire`);
        const geoFire = new GeoFire_1.default(appGeofireDbRef);
        let numLatitude;
        try {
            numLatitude = Number((0, getNumberFromUnknown_1.default)(latitude).toFixed(7));
        }
        catch (_a) {
            throw Error(`Invalid latitude [${latitude}]`);
        }
        let numLongitude;
        try {
            numLongitude = Number((0, getNumberFromUnknown_1.default)(longitude).toFixed(7));
        }
        catch (_b) {
            throw Error(`Invalid longitude [${longitude}]`);
        }
        if (!keyLocation || typeof keyLocation !== 'string') {
            throw new Error('Key location must to be an string');
        }
        await geoFire.set(keyLocation, [numLatitude, numLongitude], data || null);
        executeProcesses(undefined, callbacks.successProcess);
    }
    catch (error) {
        executeProcesses(functionId, callbacks.errorProcess, `${error}`);
    }
};
exports.default = callableGeoFireSetBuilder;
